/**
 * Chat Page - עמוד צ'אט
 * LLM-powered investment advisory chat with real-time messaging
 */

import ChatInterface from '../components/chat/ChatInterface'

export default function ChatPage() {
  return (
    <div className="h-full">
      <ChatInterface />
    </div>
  )
}
